import MarketLayoutDescriptors from './_market-layout-descriptors.js'
import SelectionHeaders from './_selection-headers.js'
import FlexPane from './_flex-pane.js'
import Market from './_market.js'
import MenuRow from './_menu-row.js'
import Text from './_text.js'
import ImageButton from './_image-button.js'
import SelectionButton from './_selection-button.js'

export default {
  name: 'CorrectScoreMarketContent',
  values: {
    isMainPivotDefault: true,
    layoutDescriptors: {
      configSet: MarketLayoutDescriptors,
      configValues: {
        default: {
          selectionsHeaderContent: 'participant',
        },
      },
    },
    selectionHeaders: {
      configSet: SelectionHeaders,
      configValues: {
        container: {
          style: {
            height: '25px',
            alignItems: 'center',
          },
        },
        label: {
          ellipsisOnLineNumber: 2,
        },
      },
    },
    marketsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    market: {
      configSet: Market,
      configValues: {},
    },
    contentContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
          padding: '8px',
        },
      },
    },
    categorySelector: {
      configSet: MenuRow,
      configValues: {
        style: {
          container: {
            padding: 0,
            width: '100%',
          },
        },
        item: {
          unselected: {
            style: {
              base: {
                flexGrow: 0,
                minWidth: '60px',
                padding: '0 4px',
              },
            },
          },
          selected: {
            style: {
              base: {
                flexGrow: 0,
                minWidth: '60px',
                padding: '0 4px',
              },
            },
          },
          indicator: {
            style: {
              base: {
                width: 'calc(100% - 8px)',
              },
            },
          },
        },
        buttonScrollPane: {
          contentContainer: {
            style: {
              _mobile_padding: 0,
            },
          },
        },
      },
    },
    allViewContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    mainViewContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          _mobile_flexDirection: 'column',
        },
      },
    },
    scorePartContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
          width: '232px',
        },
      },
    },
    participantName: {
      configSet: Text,
      configValues: {
        truncate: true,
        ellipsisOnLineNumber: 2,
        style: {
          textAlign: 'center',
        },
        container: {
          height: '32px',
          alignItems: 'center',
        },
      },
    },
    scorePartContent: {
      configSet: FlexPane,
      configValues: {
        style: {
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
    },
    scoreText: {
      configSet: FlexPane,
      configValues: {
        style: {
          textAlign: 'center',
          maxWidth: '40px',
        },
      },
    },
    correctScoreNumber: {
      configSet: Text,
      configValues: {
        style: {
          textAlign: 'center',
        },
      },
    },
    plusButtonEnabled: {
      configSet: ImageButton,
      configValues: {
        button: {
          style: {
            base: {
              justifyContent: 'flex-start',
            },
          },
        },
        buttonIcon: {
          src: 'plus-button',
          style: {
            minWidth: '16px',
            minHeight: '16px',
            padding: '0',
          },
        },
        innerContainer: {
          style: {
            flexGrow: '0',
            flexDirection: 'row',
            padding: '12px',
          },
        },
      },
    },
    plusButtonDisabled: {
      configSet: ImageButton,
      configValues: {
        button: {
          style: {
            base: {
              justifyContent: 'flex-start',
            },
          },
        },
        buttonIcon: {
          src: 'plus-button',
          style: {
            minWidth: '16px',
            minHeight: '16px',
            padding: '0',
          },
        },
        innerContainer: {
          style: {
            flexGrow: '0',
            flexDirection: 'row',
            padding: '12px',
          },
        },
      },
    },
    minusButtonEnabled: {
      configSet: ImageButton,
      configValues: {
        button: {
          style: {
            base: {
              justifyContent: 'flex-end',
            },
          },
        },
        buttonIcon: {
          src: 'minus-button',
          style: {
            minWidth: '16px',
            minHeight: '16px',
            padding: '0',
          },
        },
        innerContainer: {
          style: {
            flexGrow: '0',
            flexDirection: 'row',
            padding: '12px',
          },
        },
      },
    },
    minusButtonDisabled: {
      configSet: ImageButton,
      configValues: {
        button: {
          style: {
            base: {
              justifyContent: 'flex-end',
            },
          },
        },
        buttonIcon: {
          src: 'minus-button',
          style: {
            minWidth: '16px',
            minHeight: '16px',
            padding: '0',
          },
        },
        innerContainer: {
          style: {
            flexGrow: '0',
            flexDirection: 'row',
            padding: '12px',
          },
        },
      },
    },
    mainContainer: {
      configSet: FlexPane,
      configValues: {
        separator: {
          style: {
            size: '1px',
            margin: '12px 0 18px',
          },
        },
        style: {
          _desktop_flexBasis: '60%',
        },
      },
    },
    selectionButtonContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          _desktop_flexBasis: '40%',
          justifyContent: 'center',
          alignItems: 'center',
        },
      },
    },
    selectionButton: {
      configSet: SelectionButton,
      configValues: {
        view: {
          layoutDirection: 'vertical',
          showSetGameInfoText: false,
          nameDisplay: 'hide',
          _mobile_nameDisplay: 'hide',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
